<div class="std-margin flex space-between">
  <span class="pointer uppercase bold" (click)="selectMode()"><i class="fa hlf-margin-right" [ngClass]="{'fa-boxes': mode == 'quantity', 'fa-coins': mode == 'worth'}"></i>{{(mode=='quantity' ? 'Xem theo số lượng' : 'Xem theo giá trị') | lang}}</span>
  <date-picker [force]="true" [handler]="handler"></date-picker>
</div>
<panel *ngIf="range && (!loading || !goods.empty)">

  <ng-container header *ngFor="let i of paths; index as ix">
    <span *ngIf="ix > 0" class="hlf-margin-left hlf-margin-right">|</span>
    <span *ngIf="ix != 2" [ngClass]="{'pointer text-primary': i.children.length > 0 && i != report}" (click)="open(i)">{{i.name}}</span>
    <good *ngIf="ix == 2" [sku]="i.name"></good>
  </ng-container>

  <text-filter [target]="goods" [placeholder]="'Tìm khách hàng'" right></text-filter>


  <table responsive class="data hover" *ngIf="mode == 'worth'">
    <tr>
      <th priority="8" class="text-top text-right" style="width: 0">STT</th>
      <th priority="1" class="text-top text-left"><sortable [target]="goods" [extractor]="extractor('last-of-path')">{{primaryLabel}}</sortable></th>
      <th priority="2" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('export')">{{'Xuất bán' | lang}}</sortable></th>
      <th priority="4" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('discount')">{{'Lỗi/thiếu mét' | lang}}</sortable></th>
      <th priority="3" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('return')">{{'Khách trả hàng' | lang}}</sortable></th>
      <th priority="7" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('exchange')">{{'Tỷ giá' | lang}}</sortable></th>
      <th priority="6" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('gross')">{{'Lãi gộp' | lang}}</sortable></th>
      <th priority="5" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('%')">{{'Lãi xuất' | lang}}</sortable></th>
    </tr>
    <tr *ngFor="let i of goods.pageMatches; index as ix">

      <td><small>{{ix + 1 + goods.pageIndex * goods.pageSize}}</small></td>
      <td>
        <div class="spacy bold" [ngClass]="{'pointer text-primary': i.children.length > 0, 'text-warning': i.children.length < 1}" (click)="open(i)">
          <span *ngIf="paths.length != 2">{{i.Path.last()}}</span>
          <good *ngIf="paths.length == 2" [sku]="i.Path.last()"></good>
        </div>
        <small *ngIf="paths.length == 1">{{i.children.length}}<unit>{{'mã hàng' | lang}}</unit></small>
        <small *ngIf="paths.length == 2">{{i.children.length}}<unit>{{'mã màu' | lang}}</unit></small>
      </td>

      <td class="nowrap">
        <number class="bold" [sign]="false" [value]="i.quote('export','VND')"></number>
        <vnd></vnd>

        <br />

        <small *ngIf="total('Count', i.Exports) > 0" class="pointer" (click)="openStatistics(i, 'exports')">
          <number [sign]="false" [decimal]="0" [value]="i.gross('export','CNY')"></number>
          <b> + </b>
          <number class="bold" [sign]="false" [good]="'none'" [value]="i.base('export','CNY')"></number>
          <cny></cny> <i class="fa fa-info-circle text-primary hlf-margin-left"></i>
        </small>
      </td>

      <td class="nowrap">
        <number class="bold" [good]="'negative'" [sign]="false" [value]="i.quote('discount', 'VND')" [decimal]="0"></number>
        <vnd></vnd>

        <br />

        <small *ngIf="total('Discount', i.Exports, i.Imports) > 0">
          <number [sign]="false" [value]="i.gross('discount', 'CNY')" [decimal]="0"></number>
          <b> + </b>
          <number class="bold" [sign]="false" [good]="'none'" [value]="i.base('discount', 'CNY')"></number>
          <cny></cny>
        </small>

      </td>

      <td class="nowrap">
        <number class="bold" [good]="'negative'" [sign]="false" [value]="i.quote('return', 'VND')" [decimal]="0"></number>
        <vnd></vnd>

        <br />

        <small *ngIf="total('Count', i.Returns) > 0" class="pointer" (click)="openStatistics(i, 'returns')">
          <number [sign]="false" [value]="i.gross('return', 'CNY')" [decimal]="0"></number>
          <b> + </b>
          <number class="bold" [sign]="false" [good]="'none'" [value]="i.base('return', 'CNY')"></number>
          <cny></cny> <i class="fa fa-info-circle text-primary hlf-margin-left"></i>
        </small>

      </td>

      <td class="nowrap">
        <ng-container *ngIf="i.exchange != 0">
          <number [good]="'none'" [sign]="false" [value]="i.exchange" [decimal]="0"></number>
          <vnd-per-cny></vnd-per-cny>
        </ng-container>
      </td>
      <td class="nowrap">
        <number class="bold" [value]="i.gross('total','VND')" [decimal]="0"></number>
        <vnd></vnd>

        <br />

        <small *ngIf="i.gross('total','CNY') != 0">
          <number [good]="'positive'" [value]="i.gross('total', 'CNY')" [decimal]="0"></number>
          <b> / </b>
          <number [good]="'none'" [sign]="false" [value]="i.base('profitable', 'CNY')" [decimal]="0"></number>
          <cny></cny>
        </small>
      </td>
      <td class="nowrap">
        <number [good]="'positive'" [value]="i.base('profitable', 'CNY') != 0 ? i.gross('total', 'CNY') * 100 / i.base('profitable', 'CNY') : 0" [decimal]="1"></number>
        <unit>%</unit>
      </td>
    </tr>
    <tr *ngIf="goods.pages.length > 1">
      <td [colSpan]="8" class="text-center" style="z-index: unset"><pagination [target]="goods"></pagination></td>
    </tr>
    <tr class="footer" *ngIf="goods.matches.length > 1">
      <td></td>
      <td class="bold">{{'TỔNG' | lang}} ({{goods.matches.length}})</td>
      <td>
        <number class="bold" [sign]="false" [good]="'positive'" [value]="statistics('export')" [decimal]="0"></number>
        <vnd></vnd>
      </td>
      <td>
        <number class="bold" [sign]="false" [good]="'negative'" [value]="statistics('discount')" [decimal]="0"></number>
        <vnd></vnd>
      </td>
      <td>
        <number class="bold" [sign]="false" [good]="'negative'" [value]="statistics('return')" [decimal]="0"></number>
        <vnd></vnd>
      </td>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="statistics('exchange')" [decimal]="0"></number>
        <cny-per-vnd></cny-per-vnd>
      </td>
      <td>
        <number class="bold" [value]="statistics('gross-value')" [decimal]="0"></number>
        <vnd></vnd>
      </td>
      <td>
        <number class="bold" [value]="statistics('gross-percentage') * 100" [decimal]="1"></number>
        <unit>%</unit>
      </td>
    </tr>
  </table>

  <table responsive class="data hover" *ngIf="mode == 'quantity'">
    <tr>
      <th priority="5" class="text-top text-right" style="width: 0">STT</th>
      <th priority="1" class="text-top text-left"><sortable [target]="goods" [extractor]="extractor('last-of-path')">{{primaryLabel}}</sortable></th>
      <th priority="2" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('export-quantity')">{{'Xuất bán' | lang}}</sortable></th>
      <th priority="4" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('discount-quantity')">{{'Lỗi/thiếu' | lang}}</sortable></th>
      <th priority="3" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('return-quantity')">{{'Khách trả hàng' | lang}}</sortable></th>
    </tr>
    <tr *ngFor="let i of goods.pageMatches; index as ix">
      <td><small>{{ix + 1 + goods.pageIndex * goods.pageSize}}</small></td>
      <td>
        <div class="spacy bold" [ngClass]="{'pointer text-primary': i.children.length > 0, 'text-warning': i.children.length < 1}" (click)="open(i)">
          <span *ngIf="paths.length != 2">{{i.Path.last()}}</span>
          <good *ngIf="paths.length == 2" [sku]="i.Path.last()"></good>
        </div>
        <small *ngIf="paths.length == 1">{{i.children.length}}<unit>{{'mã hàng' | lang}}</unit></small>
        <small *ngIf="paths.length == 2">{{i.children.length}}<unit>{{'mã màu' | lang}}</unit></small>
      </td>

      <td class="nowrap">
        <div *ngIf="i.Exports.LengthCount > 0"><number class="bold" [sign]="false" [value]="i.Exports.LengthQuantity" [decimal]="1"></number><m></m></div>
        <div *ngIf="i.Exports.WeightCount > 0"><number class="bold" [sign]="false" [value]="i.Exports.WeightQuantity" [decimal]="1"></number><kg></kg></div>
        <div *ngIf="total('Count', i.Exports) == 0">0</div>

        <small *ngIf="total('Count', i.Exports) > 0" class="pointer" (click)="openStatistics(i, 'exports')">
          <number class="bold" [sign]="false" [good]="'none'" [value]="total('Count', i.Exports)"></number>
          <unit>{{'cây' | lang}}</unit> <i class="fa fa-info-circle text-primary hlf-margin-left"></i>
        </small>
      </td>
      <td class="nowrap">
        <div *ngIf="i.Exports.LengthDiscount > 0"><number class="bold" [good]="'negative'" [sign]="false" [value]="i.Exports.LengthDiscount" [decimal]="1"></number><m></m></div>
        <div *ngIf="i.Exports.WeightDiscount > 0"><number class="bold" [good]="'negative'" [sign]="false" [value]="i.Exports.WeightDiscount" [decimal]="1"></number><kg></kg></div>
        <div *ngIf="total('Discount', i.Exports) == 0">0</div>

        <small *ngIf="total('Discount', i.Imports)  > 0">
          <number [sign]="false" [value]="total('Discount', i.Imports) - total('Discount', i.Exports)" [decimal]="1"></number>
          <b> + </b>
          <number class="bold" [sign]="false" [good]="'none'" [value]="total('Discount', i.Imports)" [decimal]="1"></number>
        </small>
      </td>

      <td class="nowrap">
        <div *ngIf="i.Returns.LengthCount > 0"><number class="bold" [good]="'negative'" [sign]="false" [value]="i.Returns.LengthQuantity" [decimal]="1"></number><m></m></div>
        <div *ngIf="i.Returns.WeightCount > 0"><number class="bold" [good]="'negative'" [sign]="false" [value]="i.Returns.WeightQuantity" [decimal]="1"></number><kg></kg></div>
        <div *ngIf="total('Count', i.Returns) < 1">0</div>        

        <small *ngIf="total('Count', i.Returns) > 0" class="pointer" (click)="openStatistics(i, 'returns')">
          <number [sign]="false" [good]="'negative'" [value]="total('Count', i.Returns)" [decimal]="0"></number>
          <unit>{{'cây' | lang}}</unit> <i class="fa fa-info-circle text-primary hlf-margin-left"></i>
        </small>
      </td>

    </tr>

    <tr *ngIf="goods.pages.length > 1">
      <td [colSpan]="5" class="text-center" style="z-index: unset; display: table-cell !important"><pagination [target]="goods"></pagination></td>
    </tr>
    <tr class="footer" *ngIf="goods.matches.length > 1">
      <td></td>
      <td class="bold">{{'TỔNG' | lang}} ({{goods.matches.length}})</td>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="sum('Exports', 'LengthQuantity') + sum('Exports', 'WeightQuantity')" [decimal]="1"></number>
        <m *ngIf="sum('Exports', 'LengthCount') > 0 && sum('Exports', 'WeightCount') < 1"></m>
        <kg *ngIf="sum('Exports', 'LengthCount') < 1 && sum('Exports', 'WeightCount') > 0"></kg>
        <unit *ngIf="sum('Exports', 'LengthCount') > 0 && sum('Exports', 'WeightCount') > 0">{{'đv' | lang}}</unit>
        <br />
        <small *ngIf="sum('Exports','LengthCount') + sum('Exports','WeightCount') > 0">
          <number class="bold" [sign]="false" [good]="'none'" [value]="sum('Exports','LengthCount') + sum('Exports','WeightCount')" [decimal]="0"></number>
          <unit>{{'cây' | lang}}</unit>
        </small>
      </td>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="sum('Exports', 'LengthDiscount') +sum('Exports', 'WeightDiscount') " [decimal]="1"></number>
        <m *ngIf="sum('Exports', 'LengthDiscount') > 0 && sum('Exports', 'WeightDiscount') < 1"></m>
        <kg *ngIf="sum('Exports', 'LengthDiscount') < 1 && sum('Exports', 'WeightDiscount') > 0"></kg>
        <unit *ngIf="sum('Exports', 'LengthDiscount') > 0 && sum('Exports', 'WeightDiscount') > 0">{{'đv' | lang}}</unit>
      </td>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="sum('Returns', 'LengthQuantity') + sum('Returns', 'WeightQuantity')" [decimal]="1"></number>
        <m *ngIf="sum('Returns', 'LengthCount') > 0 && sum('Returns', 'WeightCount') < 1"></m>
        <kg *ngIf="sum('Returns', 'LengthCount') < 1 && sum('Returns', 'WeightCount') > 0"></kg>
        <unit *ngIf="sum('Returns', 'LengthCount') > 0 && sum('Returns', 'WeightCount') > 0">{{'đv' | lang}}</unit>
        <br />
        <small *ngIf="sum('Returns', 'LengthCount') + sum('Returns', 'WeightCount') > 0">
          <number class="bold" [sign]="false" [good]="'none'" [value]="sum('Returns', 'LengthCount') + sum('Returns', 'WeightCount')" [decimal]="0"></number>
          <unit>{{'cây' | lang}}</unit>
        </small>
      </td>

    </tr>
  </table>
</panel>

<ngx-loading [show]="loading" [config]="{fullScreenBackdrop: true}"></ngx-loading>
